import { ServicioAdicional } from "../../entities/catalogos/ServicioAdicional";
import { IRecoleccion } from "../../redux/types/recoleccionActionTypes";

const CONCEPTO_ID = {
    cargoPorCitaRad: 9,
    cargoPorCitaEad: 12,
    fleteCargoEadFueraHorario: 6,
    fleteCargoRadFueraHorario: 47,
} as const;

const CARGOS_RAD_MODALIDAD_E3 = new Set<number>([
    CONCEPTO_ID.cargoPorCitaRad,
    CONCEPTO_ID.fleteCargoRadFueraHorario,
]);

const CARGOS_EAD_MODALIDAD_E3 = new Set<number>([
    CONCEPTO_ID.fleteCargoEadFueraHorario,
]);

type ModalidadRad = "normal" | "cita" | "fueraHorario";
type ModalidadEad = "normal" | "cita" | "fueraHorario";

export const detectarModalidadRadOrigen = (guiaOrigen: IRecoleccion): ModalidadRad => {
    if (guiaOrigen.tipoDeRecoleccionOrigen === 3 || guiaOrigen.EsFueraHorario === true) {
        return "fueraHorario";
    }
    if (guiaOrigen.tipoDeRecoleccionOrigen === 2 && guiaOrigen.fechaCita) {
        return "cita";
    }
    return "normal";
};

export const detectarModalidadEadDestino = (guiaDestino: IRecoleccion): ModalidadEad => {
    if (guiaDestino.tipoDeRecoleccionDestino === 3 || guiaDestino.EsFueraHorario === true) {
        return "fueraHorario";
    }
    if (guiaDestino.tipoDeRecoleccionDestino === 2 && guiaDestino.fechaCita) {
        return "cita";
    }
    return "normal";
};

const esCargoAutomaticoModalidadE3 = (conceptoId: number): boolean =>
    CARGOS_RAD_MODALIDAD_E3.has(conceptoId) || CARGOS_EAD_MODALIDAD_E3.has(conceptoId);

export const aplicarCargosAutomaticosModalidadGuia = (
    servicios: ServicioAdicional[],
    guiaOrigen: IRecoleccion,
    guiaDestino: IRecoleccion
): ServicioAdicional[] => {
    const modalidadRad = detectarModalidadRadOrigen(guiaOrigen);
    const modalidadEad = detectarModalidadEadDestino(guiaDestino);

    return servicios.map(servicio => {
        if (!esCargoAutomaticoModalidadE3(servicio.id)) {
            return servicio;
        }

        const copia = new ServicioAdicional(servicio);

        if (CARGOS_RAD_MODALIDAD_E3.has(copia.id)) {
            copia.seleccionado = false;
            copia.aplicaOrigen = false;
            copia.aplicaDestino = false;

            if (modalidadRad === "cita" && copia.id === CONCEPTO_ID.cargoPorCitaRad) {
                copia.seleccionado = true;
                copia.aplicaOrigen = true;
                copia.aplicaDestino = false;
            } else if (modalidadRad === "fueraHorario" && copia.id === CONCEPTO_ID.fleteCargoRadFueraHorario) {
                copia.seleccionado = true;
                copia.aplicaOrigen = true;
                copia.aplicaDestino = false;
            }
        }

        if (CARGOS_EAD_MODALIDAD_E3.has(copia.id)) {
            copia.seleccionado = false;
            copia.aplicaOrigen = false;
            copia.aplicaDestino = false;

            if (modalidadEad === "fueraHorario" && copia.id === CONCEPTO_ID.fleteCargoEadFueraHorario) {
                copia.seleccionado = true;
                copia.aplicaOrigen = false;
                copia.aplicaDestino = true;
            }
        }

        return copia;
    });
};
